import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'eventType',
})
export class EventTypePipe implements PipeTransform {
  transform(calendarType: string): string {
    if (!calendarType) return '';

    const trimmedType = calendarType.trim().toLowerCase();
    switch (trimmedType) {
      case 'personal event type':
        return 'Personal';
      case 'team event type':
        return 'Team';
      default:
        return calendarType.trim();
    }
  }
}
